import { render, staticRenderFns } from "./sale-order-download.vue?vue&type=template&id=220b33a0&scoped=true&"
import script from "./sale-order-download.vue?vue&type=script&lang=js&"
export * from "./sale-order-download.vue?vue&type=script&lang=js&"
import style0 from "./sale-order-download.vue?vue&type=style&index=0&id=220b33a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b33a0",
  null
  
)

export default component.exports